/*
 *   File : main-layout.js
 *   Author : https://evoqins.com
 *   Description : main layout component
 *   Integrations : NA
 *   Version : 1.0.0
 */

import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { Footer, Header, Sidebar } from "../Navigation";
import ScrollToTop from "./scrol-to-top";

export default function MainLayout() {
  // desktop collapse (remembered across reloads)
  const [isMenuOpen, setIsMenuOpen] = useState(() => {
    try {
      return localStorage.getItem("sidebar_collapsed") !== "true";
    } catch {
      return true;
    }
  });
  const [isOffcanvasOpen, setIsOffcanvasOpen] = useState(false); // mobile offcanvas

  useEffect(() => {
    try {
      localStorage.setItem("sidebar_collapsed", String(!isMenuOpen));
    } catch {
      // storage unavailable; keep in-memory state only
    }
  }, [isMenuOpen]);

  // prevent body scroll when offcanvas open
  useEffect(() => {
    document.body.style.overflow = isOffcanvasOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOffcanvasOpen]);

  // close on ESC
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") setIsOffcanvasOpen(false);
    };
    if (isOffcanvasOpen) document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [isOffcanvasOpen]);

  return (
    <div className="container-fluid e-main-bg min-vh-100">
      <div className="p-md-3 p-sm-1 p-0">
        <ScrollToTop />
        <div className="row">
          {/* Desktop sidebar (xl and up) */}
          <div
            className={`${
              isMenuOpen ? "col-2" : "col-1"
            } d-xl-block d-none p-0`}
            style={{
              position: "sticky",
              top: "16px",
              alignSelf: "flex-start",
              height: "100vh",
              overflowY: "auto",
            }}
          >
            <Sidebar toggle={isMenuOpen} />
          </div>

          {/* Main content */}
          <div
            className={`${
              isMenuOpen ? "col-xl-10 col-12" : "col-xl-11 col-12"
            } min-vh-100 d-flex flex-column row-gap-3`}
          >
            <div
              className="flex-grow-1 e-glass-bg position-relative"
              style={{ zIndex: 2 }}
            >
              <div className="row">
                <Header
                  // keep your existing props
                  handleToggle={setIsMenuOpen}
                  // new prop to open mobile offcanvas
                  openOffcanvas={() => setIsOffcanvasOpen(true)}
                />
              </div>
              <Outlet />
            </div>
            <Footer />
          </div>
        </div>
      </div>

      {/* React-controlled offcanvas for mobile */}
      <div
        aria-hidden={!isOffcanvasOpen}
        className={`react-offcanvas-panel ${isOffcanvasOpen ? "open" : ""}`}
        role="dialog"
        aria-modal="true"
      >
        <Sidebar
          type="offcanvas"
          toggle={true}
          handleCloseOffCanvas={() => setIsOffcanvasOpen(false)}
        />
      </div>

      {/* Backdrop */}
      {isOffcanvasOpen && (
        <div
          className="react-offcanvas-backdrop"
          onClick={() => setIsOffcanvasOpen(false)}
          aria-hidden="true"
        />
      )}
    </div>
  );
}
